import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import {FileManagerService} from '../../main/file-manager/file-manager.service';
import {ProgressBarMode} from '@angular/material/progress-bar';
import * as JSZip from 'jszip';
import {NICEStudioScript} from '../../models/NICE_StudioScript.model';
import {IcDataService} from '../../services/ic-data.service';
import {first, Observable, of, switchMap} from 'rxjs';
import {IcDataStudioScriptsService} from "../../services/ic-data.studio-scripts.service";


@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './upload-scripts-dialog.component.html',
    styleUrls: ['./upload-scripts-dialog.component.scss']
})

export class UploadScriptsDialogComponent implements OnInit {
    completeProgress = 0;
    totalProcessCount = 0;
    currentProcessIndex = 0;
    currentOverwriteMethod = 'None';
    zippedScripts = [];
    statusMessage: string;
    showOverwrite = false;
    processingFileName: string;
    progressMode: ProgressBarMode = 'determinate';
    showConfirm = false;
    showProgress = false;

    constructor(
        private dialogRef: MatDialogRef<UploadScriptsDialogComponent>,
        public _fileManagerService: FileManagerService,
        private _icData: IcDataService,
        private _scriptService: IcDataStudioScriptsService,
        @Inject(MAT_DIALOG_DATA) public data: SaveFileModel
    ) {

    }

    ngOnInit(): void {
        //this.processingFileName = this.data.fileList[0].fullPath;
        const file = this.data.fileList[0];
        const fileExtension = file.name.substring(file.name.length - 3);
        if (fileExtension.toLocaleUpperCase() === 'ZIP') {
            this.getZipContent(file).then( (zScripts) => {
                    this.zippedScripts = zScripts;
                    this.totalProcessCount = this.zippedScripts.length;
                    this.processingFileName = this.zippedScripts[0].scriptPath;
                }
            );
        }
        if (fileExtension.toLocaleUpperCase() === 'XML') {
            const studioScript = new NICEStudioScript();
            studioScript.scriptPath = file.name.substring(0, file.name.length - 4);
            studioScript.scriptPath.replace('/', '\\');
            this.getFileAsync(file).then( (scriptBody) =>
                {
                    studioScript.body = (scriptBody as string).split(',')[1];
                    this.zippedScripts.push(studioScript);
                    this.totalProcessCount = this.zippedScripts.length;
                    this.processingFileName = this.zippedScripts[0].scriptPath;
                }
            );

        }
        this.showConfirm = this.data.mustConfirm;
    }



    async getBase64File(file: File): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event: any) => {
                resolve((event.target.result as string).split(',')[1]);
            };
        });
    }
    async getZipContent(file): Promise<NICEStudioScript[]> {
        const jszip = new JSZip();
        const studioScriptArray = [];
        const zip = await jszip.loadAsync(file);

        for (const filename of Object.keys(zip.files)) {
            const fileEntry = zip.files[filename];

            // Check if the entry is not a directory
            if (!fileEntry.dir) {
                const studioScript = new NICEStudioScript();
                studioScript.scriptPath = filename.substring(0, filename.length - 4);
                studioScript.scriptPath = studioScript.scriptPath.replace(/\//g, '\\');
                studioScript.body = await fileEntry.async('base64');
                studioScriptArray.push(studioScript);
            }
        }
        return new Promise<NICEStudioScript[]>((resolve, reject) => {
            resolve(studioScriptArray);
        });
    }

    async getFileAsync(inputFile: File): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event: any) => {
                const data = event.target.result;
                resolve(data);
            };
            reader.readAsDataURL(inputFile);
        });
    }

    uploadFiles(): Observable<any> {
            this.showProgress = true;
            this.progressMode = 'determinate';
            this.totalProcessCount = this.zippedScripts.length;
            if (this.totalProcessCount > this.currentProcessIndex) {
                this.completeProgress = Math.round((this.currentProcessIndex) * 100 / this.totalProcessCount);
                this.processingFileName = this.zippedScripts[this.currentProcessIndex].scriptPath;
                return this._scriptService.saveStudioScript(this.zippedScripts[this.currentProcessIndex]).pipe(
                    switchMap(
                        (result) => {
                            this.currentProcessIndex = this.currentProcessIndex + 1;
                            return this.uploadFiles();
                        })
                );
            }
            else {
                return of(true);
            }
    }


    cancelProcess(): void {
        this.dialogRef.close(false);
    }

    confirmSave(): void {
        this.showConfirm = false;
        this.uploadFiles().pipe(first()).subscribe((processResult) => {
            this.dialogRef.close(processResult);
            }
        );
    }
}

export class SaveFileModel {
    constructor(
        public fileList: any[] = [],
        public folderPath= '',
        public mustConfirm= false,
        public overwriteByDefault = false,
    )
    {

    }
}


